import imagePlaceHolder from "../assets/images/imagePlaceHolder.svg"
import PDF from "../assets/pdf/W_LPCB_Issue2_C1457_SFS-Certificate.pdf"
import { type breadCrumbsInterface } from "../components/commons/breadcrumb"

export const pageContentWidth = 883
export const mobileBreakpoint = 991
export const mobileMenuBarHeight = 56
export const mobileMenuWidth = "80vw"
// Shared container width for the Header and Footer chrome only (not page body
// content - see pageContentWidth above for that). Keeps both in alignment at
// every breakpoint above mobile/tablet (<992px, i.e. Chakra's lg/xl/2xl).
export const headerFooterContentWidth = {
  base: "100%",
  lg: "90%",
  xl: "90%",
  "2xl": "85%"
}
export const headerFooterMaxWidth = "1500px"
export const gridUnit = "100%"
export const componentMinHeight = 700
export const imageSliderWidth = 320
export const imageSliderWidthXL = 400
export const imageSliderWidth2XL = 440
export const RECAPTCHA_SITE_KEY_PROD = import.meta.env.VITE_RECAPTCHA_SITE_KEY_PROD || "6LcxIVEpAAAAAFYN0veG3ORgZRADQMXjr40MBJEs"
export const RECAPTCHA_SITE_KEY_TEST = import.meta.env.VITE_RECAPTCHA_SITE_KEY_TEST || "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
export const TOKEN_NAME = "snap-token"
export const LOGGED_IN = "logged-in"
export const USER_DETAILS_NAME = "user-details"
export const RETURN_URL = "return-url"
export const REMEMBER_ME = "remember-me"
export const FORBIDDEN_ACCESS_MESSAGE = "Forbidden access!"
export const USER_NOT_VERIFIED = "User has not been verified!"
export const USER_NOT_VERIFIED_MESSAGE = "Please verify your email address to access the application."
export const LOCAL_STORAGE_REGISTED_EMAIL = "registered_email"
export const SESSION_EXPIRED_KEY = "session-expired"

// Get protocol from current URL (http:// or https://)
const getProtocol = (): string => {
  if (typeof window !== "undefined") {
    return window.location.protocol === "https:" ? "https://" : "http://"
  }
  return "https://" // Default to https:// for SSR
}

const protocol = getProtocol()

export const paths = {
  LOCAL: "http://localhost:4005/",
  REMOTE: import.meta.env.VITE_API_URL_REMOTE || `${protocol}16.176.138.221:4005`,
  REMOTE_FILE_UPLOAD_URL: import.meta.env.VITE_REMOTE_FILE_UPLOAD_URL || `${protocol}16.176.138.221:4005/upload`,
  CLOUD_PATH: import.meta.env.VITE_CLOUD_PATH || "https://dgcj3bec7tz3k.cloudfront.net"
}

export const IonContentId = "main-content"
export const breadCrumbFirstLevel: breadCrumbsInterface = {
  firstLevel: {
    title: "Home",
    path: "/"
  }
}

export const breadCrumbReportsAndResourcesSecondLevel: breadCrumbsInterface = {
  secondLevel: {
    title: "Reports & Resources",
    path: "/reports/all"
  }
}
export const breadCrumbFMPSecondLevel: breadCrumbsInterface = {
  secondLevel: {
    title: "My FMPs",
    path: "/fmp/my-fmp"
  }
}

export const breadCrumbProductFilterSecondLevel: breadCrumbsInterface = {
  secondLevel: {
    title: "Product Filter & FMP Builder",
    path: "/fmp/productFilter"
  }
}

export const breadCrumbProductsSecondLevel: breadCrumbsInterface = {
  secondLevel: {
    title: "Products",
    path: "/all-products"
  }
}

export const breadCrumbAccessoriesThirdLevel: breadCrumbsInterface = {
  thirdLevel: {
    title: "Accessories",
    path: "/products/accessories"
  }
}

export const breadCrumbSealantThirdLevel: breadCrumbsInterface = {
  thirdLevel: {
    title: "Sealant",
    path: "/products/sealant"
  }
}

export const Paths = {
  home: "/home",
  Product: {
    all: "/all-products",
    sub: {
      castIn: {
        all: "/products/cast-in-fire-collars",
        product: "/products/cast-in-fire-collars/:id"
      },
      retroFit: {
        all: "/products/retrofit-fire-collars",
        product: "/products/retrofit-fire-collars/:id"
      },
      gas: {
        all: "/products/gas-fire-collars",
        product: "/products/gas-fire-collars/:id"
      },
      endless: {
        all: "/products/endless-fire-collars",
        product: "/products/endless-fire-collars/:id"
      },
      accessories: {
        all: "/products/accessories",
        product: "/products/accessories/:id"
      },
      accessory: {
        all: "/products/accessory",
        product: "/products/accessory/:id"
      },
      multiservice: {
        all: "/products/multi-service-fire-collars",
        product: "/products/multi-service-fire-collars/:id"
      },
      floorwasteAndShower: {
        all: "/products/fire-collar/floorwaste-and-shower"
      },
      stack: {
        all: "/products/fire-collar/stack"
      },
      fireCollarMS70R: {
        product: "/products/fire-collar/MS70R"
      },
      fireCollar: {
        all: "products/fire-collar",
        product: "/products/fire-collar/:id"
      },
      sealant: {
        all: "/products/sealant",
        category: "/products/sealant/:id"
      }
    }
  },
  LOGIN: {
    login: "/login",
    logout: "/logout"
  },
  TEST_REPORTS: "/test-reports",
  REPORTS_ALL: "/reports/all",
  UNIQUE_SOLUTIONS: "/unique",
  INSTALLATION_INSTRUCTIONS: "/instructions",
  DRAWINGS: "/drawings",
  FAQ: "/faq",
  COMPLIANCE: "/compliance",
  QUALITY: "/quality",
  TERMSANDCONDITIONS: "/terms-and-conditions",
  PRIVACYPOLICY: "/privacy-policy",
  DISTRIBUTORS: "/distributors",
  CONTACTUS: "/contact-us",
  ERROR: "/error",
  FMP: {
    all: "/fmp/my-fmp",
    PRODUCT_FILTER: "/fmp/product-filter",
    EDIT_FMP: "/fmp/edit-fmp",
    VIEW_FMP: "/fmp/view-fmp/:fmpid",
    CREATE_FMP: "/fmp/create-fmp",
    MY_FMP: "/fmp/my-fmp",
    MY_ARCHIVED_FMP: "/fmp/my-archived-fmp"
  },
  SIGNUP_CONFIRMATION: "/signUpConfirmation",
  PRODUCT_FILTER: "/product-filter"
}

export const breadCrumbAllProductsSecondLevel: breadCrumbsInterface = {
  secondLevel: {
    title: "Products",
    path: Paths.Product.all
  }
}
export const breadCrumbAllFMPs: breadCrumbsInterface = {
  secondLevel: {
    title: "all FMPs",
    path: Paths.FMP.all
  }
}
export const COLLARTYPEID = {
  CASTIN: 1,
  RETROFITFIRE: 2,
  GASFIRE: 3,
  ELECTRICALANDDATA: 4,
  ACCESSORIES: 5,
  HVAC: 6
}
export const COLLARTYPEKEY = {
  CASTIN: "cast",
  RETROFITFIRE: "retro",
  GASFIRE: "gas",
  ELECTRICALANDDATA: "data",
  ACCESSORIES: "accessory",
  HVAC: "hvac",
  MULTISERVICE: "multi-service",
  ENDLESS: "endless",
  SEALANT: "sealant"
}
export const FALLBACKIMAGES = {
  "150x150": imagePlaceHolder,
  "250x250": imagePlaceHolder
}
export const STATIC_PAGE_HEADER_HEIGHT = ["210px", "210px", "210px", "290px"]

export const TERMS_AND_CONDITIONS_TABS = {
  terms: "terms-and-conditions",
  privacyPolicy: "privacy-policy"
}
export const ACCREDIATION_PDF_LINK = PDF
export const isAndroid = (): boolean => /android/i.test(navigator.userAgent)
export const isIOS = (): boolean => /iPad|iPhone|iPod/i.test(navigator.userAgent)
export const isMobileForPDF = (): boolean => isAndroid() || isIOS()
export const safeMaxWidth = "calc(100% - (env(safe-area-inset-left) + env(safe-area-inset-right)))"
export const URLForwardSlashSeparator = "_"
export const URLForwardSlashRestore = (productId: string | undefined): string | undefined => productId?.replaceAll(URLForwardSlashSeparator, "/")
export const formatDate = (value: string | number | null): string => {
  return value ? new Date(Number(value)).toLocaleDateString() : ""
}
export enum FMPTableType {
  MY_FMP = "myFMP",
  Edit_FMP = "edit",
  MY_ARCHIVED_FMP = "myArchivedFMP",
  VIEW_FMP = "viewFMP"
}

export const defaultMenuAll = "All"
